import React, { Component } from 'react';
import { Modal, Button, List, Grid, Header } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';
import { pipe, filter, join } from 'ramda';
import TransactionTable from '../TransactionTable';
import Moment from 'react-moment';
import i18next from 'i18next';


class PurchaseOrderView extends Component {
  constructor(props) {
    super();

    this.state = {};
  }

  createInvoice= () => {
    //this.props.onSubmit(clone(this.state));
  };

  
  getMergedAddress = ({city, zip, state, country}) => {
    return pipe(
      filter(i => !!(i)),
      join(', ')
    )([zip, city, state, country]);
  }

  onExport = () => {
    this.props.onExport(this.props.data);
  }

  render() {
    const { t, data, open } = this.props;

    return (
      <Modal open={open}>
        <Modal.Header content={t('private:po.title')} />
        <Modal.Content>
          <Grid columns={2} divided>
            <Grid.Row>
              <Grid.Column>
                <List>
                  <List.Item>
                    <List.Header>{t('private:po.date')}</List.Header>
                    <Moment
                      locale={i18next.lang || 'et'}
                      format="YYYY/MM/DD hh:mm">
                      {data.createdAt}
                    </Moment>
                  </List.Item>
                  <List.Item>
                    <List.Header>{t('private:po.given_name')}</List.Header>
                    {data.given_name}
                  </List.Item>
                  <List.Item>
                    <List.Header>{t('private:po.family_name')}</List.Header>
                    {data.family_name}
                  </List.Item>
                  <List.Item>
                    <List.Header>{t('private:po.email')}</List.Header>
                    {data.email}
                  </List.Item>
                  <List.Item>
                    <List.Header>{t('private:po.phone')}</List.Header>
                    {data.phone}
                  </List.Item>
                  { data.company_name &&
                    <List.Item>
                      <List.Header>{t('private:po.company_name')}</List.Header>
                      {data.company_name}
                    </List.Item>}
                  { data.company_code &&
                    <List.Item>
                      <List.Header>{t('private:po.company_code')}</List.Header>
                      {data.company_code}
                    </List.Item>}
                  { data.coupons &&
                    <List.Item>
                      <List.Header>{t('private:po.coupons')}</List.Header>
                      {data.coupons}
                    </List.Item>}
                </List>
              </Grid.Column>
              <Grid.Column>
                <Header as='h5' content={t('private:po:address_details')} />
                <List>
                  <List.Item>
                    <List.Header>{t('private:po.address_1')}</List.Header>
                    {data.address_1}
                  </List.Item>
                  <List.Item>
                    <List.Header>{t('private:po.address_2')}</List.Header>
                    {data.address_2}
                  </List.Item>
                  <List.Item>
                    <List.Header>
                      {t('private:po.zip')} /
                      {t('private:po.city')} /
                      {t('private:po.state')} /
                      {t('private:po.country')}
                    </List.Header>
                    {this.getMergedAddress(data)}
                  </List.Item>
                  <List.Item>
                    <List.Header>{t('private:po.phone')}</List.Header>
                    {data.phone}
                  </List.Item>
                </List>           
              </Grid.Column>
            </Grid.Row>
          </Grid>
          { data.teams && data.teams.length && <TransactionTable data={data.teams}/> }
        </Modal.Content>
        <Modal.Actions>
          { this.props.isAdmin && !this.props.exportStatus &&
            <Button
              content="Export to SmartAccounts"
              onClick={this.onExport}
            />
          }
          { this.props.isAdmin && this.props.exportStatus === 'FAILED' &&
            <Button
              disabled
              negative
              content="Export failed!"
            />
          }
          { this.props.isAdmin && this.props.exportStatus && this.props.exportStatus !== 'FAILED' &&
            <Button
              disabled
              positive
              content={this.props.exportStatus}
            />
          }
          <Button
            negative
            content={t('common:cancel')}
            onClick={this.props.onClose}
          />
        </Modal.Actions>
      </Modal>
    );
  }
};

export default withNamespaces(['private', 'common'])(PurchaseOrderView);



// WEBPACK FOOTER //
// ./src/private/common/components/PurchaseOrderView/index.js